import { render } from "./EditOutboundItemsForm.vue?vue&type=template&id=12fa5799"
import script from "./EditOutboundItemsForm.vue?vue&type=script&lang=js"
export * from "./EditOutboundItemsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__